import React, { Fragment } from 'react';
import { translationsObject } from '@klp/translations';
import type { Theme } from '@material-ui/core';
import { Link, ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import { IconName, Illustration } from '@klp/design/Illustrations';
import { useKlpStyles } from '@klp/design/Theme/useKlpStyles';
import { useTranslation } from 'react-i18next';

import classNames from 'classnames';

const styles = (theme: Theme) => ({
    listItem: {
        color: theme.palette.secondary.main,
    },
    languageDivider: {
        paddingLeft: theme.spacing(0.85),
        paddingRight: theme.spacing(0.85),
        color: theme.palette.primary.mediumLight,
    },
    link: {
        transition: 'color 0.3s',
        color: theme.palette.primary.mediumLight,
        '&:hover': {
            color: theme.palette.background.paper,
            '&:before': {
                backgroundColor: theme.palette.tertiary?.medium,
            },
        },
    },
    selected: {
        color: theme.palette.background.paper,
        '&:before': {
            backgroundColor: theme.palette.background.paper,
        },
    },
});
export const SidebarLanguages = () => {
    const { i18n } = useTranslation();
    const languages = Object.keys(translationsObject);

    const classes = useKlpStyles({}, styles);

    const handleLanguageSelect = (lang: string) => () => {
        i18n.changeLanguage(lang);
    };

    return (
        <ListItem component="div" dense={true}>
            <ListItemIcon>
                <Illustration icon={IconName.GLOBE} klpColor="veryLight" />
            </ListItemIcon>
            <ListItemText
                primary={
                    <nav>
                        {languages.map((languageCode: string, key: number) => (
                            <Fragment key={key}>
                                <Link
                                    className={classNames(classes.link, {
                                        [classes.selected]:
                                            i18n.language === languageCode,
                                    })}
                                    href="#"
                                    onClick={handleLanguageSelect(languageCode)}
                                >
                                    {
                                        translationsObject[languageCode][
                                            'languageName'
                                        ]
                                    }
                                </Link>
                                {languages.length > key + 1 && (
                                    <span className={classes.languageDivider}>
                                        ▪
                                    </span>
                                )}
                            </Fragment>
                        ))}
                    </nav>
                }
            />
        </ListItem>
    );
};
